import { render, staticRenderFns } from "./SqlCode.vue?vue&type=template&id=b6089778&scoped=true&"
import script from "./SqlCode.vue?vue&type=script&lang=js&"
export * from "./SqlCode.vue?vue&type=script&lang=js&"
import style0 from "./SqlCode.vue?vue&type=style&index=0&id=b6089778&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6089778",
  null
  
)

export default component.exports